import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/assetmanagement/i18n/scope";

@Component({
    selector: "app-asset-tabs-header",
    templateUrl: "./asset-tabs-header.component.html",
    styleUrls: ["./asset-tabs-header.component.scss"],
    imports: [TranslatePipe, MatIconModule],
    viewProviders: [provideTranslationScope(scope)],
})
export class AssetTabsHeaderComponent {
    @Input() selectedTab: string;
    @Output() selectedTabChange: EventEmitter<string> = new EventEmitter<string>();

    protected select(tab: string): void {
        this.selectedTabChange.emit(tab);
    }
}
